(() => {
  class ComparisonTable extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-compare-viewport]');
      this.table = this.querySelector('table');
      this.nav = this.querySelector('[data-compare-nav]');
      this.prev = this.querySelector('[data-compare-prev]');
      this.next = this.querySelector('[data-compare-next]');
      if (!this.viewport || !this.table) return;

      this.events?.abort();
      this.observer?.disconnect();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.prev?.addEventListener('click', () => this.move(-1), options);
      this.next?.addEventListener('click', () => this.move(1), options);
      this.viewport.addEventListener('scroll', () => this.paint(), { ...options, passive: true });
      this.observer = new ResizeObserver(() => this.paint());
      this.observer.observe(this.viewport);
      this.observer.observe(this.table);
      this.paint();
    }

    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }

    move(direction) {
      const width = this.querySelector('[data-compare-product]')?.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(this.table).borderSpacing) || 0;
      const rtl = getComputedStyle(this.viewport).direction === 'rtl';
      this.viewport.scrollBy({
        left: direction * (rtl ? -1 : 1) * ((width || this.viewport.clientWidth / 2) + gap),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    }

    paint() {
      const max = this.viewport.scrollWidth - this.viewport.clientWidth;
      const position = Math.abs(this.viewport.scrollLeft);
      if (this.nav) this.nav.hidden = max <= 1;
      if (this.prev) this.prev.disabled = position <= 1;
      if (this.next) this.next.disabled = position >= max - 1;
    }
  }

  if (!customElements.get('comparison-table')) {
    customElements.define('comparison-table', ComparisonTable);
  }
})();
